import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AccordionModule } from 'primeng/accordion';
import { CalendarModule } from 'primeng/calendar';
import { IMaskModule } from 'angular-imask';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { EmpenhoExtraRoutingModule } from './empenho-extra-routing.module';
import { EmpenhoExtraListComponent } from './empenho-extra-list/empenho-extra-list.component';
import { EmpenhoExtraViewComponent } from './empenho-extra-view/empenho-extra-view.component';
import { EmpenhoExtraAnulacaoComponent } from './empenho-extra-anulacao/empenho-extra-anulacao.component';
import { RetencaoExtraComponent } from './retencao-extra/retencao-extra.component';
import { EmpenhoExtraFormComponent } from './empenho-extra-form/empenho-extra-form.component';
import { SharedModule } from 'eddydata-lib';
import { NotaEmpenhoExtraDlgComponent } from './nota-empenho-extra-dlg/nota-empenho-extra-dlg.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@NgModule({
  declarations: [
    EmpenhoExtraListComponent,
    EmpenhoExtraFormComponent,
    EmpenhoExtraViewComponent,
    EmpenhoExtraAnulacaoComponent,
    RetencaoExtraComponent,
    NotaEmpenhoExtraDlgComponent
  ],
  imports: [
    SharedModule,
    FormsModule,
    EmpenhoExtraRoutingModule,
    AutoCompleteModule,
    AccordionModule,
    CalendarModule,
    ConfirmDialogModule,
    IMaskModule,
    ToastModule,
    RadioButtonModule
  ],
  providers: [MessageService, ConfirmationService]
})
export class EmpenhoExtraModule { }
